module.exports = __webpack_public_path__ + "static/tatianawork2-f28005c3f621d489f5c23d2052c64fed.jpeg";